module.exports = __webpack_public_path__ + "static/umeizudike-16deba70096d1fc43a9f533b11842696.png";